export default class InputManager{
    constructor(){
        this.keys = new Array();
        this.mousepos = {x: 0, y: 0};
        this.mousedelta = {x: 0, y: 0};
        this.mouseUpdated = false;

        document.onkeydown = (e) => {
            this.removeKey(e.code);
            this.keys.push(e.code);
        };

        document.onmousedown = (e)=>{
            this.removeKey("click");
            this.keys.push("click");
        }

        document.onmouseup = (e)=>{
            this.removeKey("click");
        }

        document.onmousemove = (e)=>{
            this.mousepos.x = e.clientX;
            this.mousepos.y = e.clientY;
            this.mousedelta.x = e.movementX;
            this.mousedelta.y = e.movementY;
            this.mouseUpdated = true;
        }

        document.onkeyup = (e) => {
            this.removeKey(e.code);
        };

        document.oncontextmenu = (e) => {
          //  e.preventDefault();
        };
    }

    getKey(key){
        for(let i = 0; i < this.keys.length; i++){
            if(this.keys[i] == key){
                return true;
            }
        }
        return false;
    }

    removeKey(key){
        for(let i = 0; i < this.keys.length; i++){
            if(this.keys[i] == key){
                this.keys.splice(i,1);
            }
        }
    }

    hasMouseUpdate(){
        const val = this.mouseUpdated;
        this.mouseUpdated = false;
        return val;
    }
}